import React from 'react'

import NotesIcon from '@material-ui/icons/Notes'

import NavTabs from 'ui/components/NavTabs'
import { DOC_PATHS } from 'utils/constants/routerPaths'

export default function ({ currentPath }) {
  return (
    <NavTabs
      title="Documentação"
      icon={<NotesIcon fontSize="small" />}
      paths={DOC_PATHS}
      currentPath={currentPath}
    />
  )
}
